import { FC, memo } from 'react';
import styled from 'styled-components';

import { useCurrentUser } from '@redux/selectors/users';
import ShowsTabContent from '@components/searchTab/ShowsTabContent';

import HomeTabs from './components/tabs';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Home: FC = () => {
  const currentUser = useCurrentUser();

  return (
    <Container>
      {currentUser?.id ? <HomeTabs /> : <ShowsTabContent />}
    </Container>
  );
};

export default memo(Home);
